import Constants from "../common/Constants";
import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { ICourtCase } from "../model/CourtCase";
import CourtCaseMapper from "../service/CourtCaseMapper";
import CourtCaseParamMapper from "../service/CourtCaseParamMapper";

export default class FindCourtCaseDetailsForCaseDecisionInteractor {
  private resource: FindResourceEntryInteractor<ICourtCase>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(courtCaseId: number, caseDecisionId: string) {
    return this.resource.execute(
      `${Constants.courtCasesPath}/${courtCaseId}/${Constants.caseDecisionPath}`,
      CourtCaseMapper,
      CourtCaseParamMapper,
      caseDecisionId
    );
  }
}
